export default __webpack_public_path__ + "static/media/14 ProfessionalDetails – 1@3x.8928d314.png";